<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ded5">For Andy Meisenheimer and Bob Hudson at Zondervan.<br/>Thanks, guys. Let’s do three more.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c6.vue?9d3e737a